import React from 'react';
import InterestSwipeSessionView from './InterestSwipeSessionView';
import { useInterestTriGroupSession } from '../../hooks/useInterestTriGroupSession';

function InterestTriGroupSwipeSession({
  paper,
  usedDemoFallback,
  savedProgress = null,
  onProgressReload,
  hasCompletedInterestTest = false,
  onShowResults,
  sidebarLayout = false
}) {
  const sessionUi = useInterestTriGroupSession({
    paper,
    savedProgress,
    onProgressReload
  });

  return (
    <InterestSwipeSessionView
      ConfirmDialog={sessionUi.ConfirmDialog}
      t={sessionUi.t}
      lang={sessionUi.lang}
      paper={paper}
      usedDemoFallback={usedDemoFallback}
      phase={sessionUi.phase}
      canResume={sessionUi.canResume}
      handleContinueSession={sessionUi.handleContinueSession}
      handleBeginSessionClick={sessionUi.handleBeginSessionClick}
      isBeginningSession={sessionUi.isBeginningSession}
      currentItem={sessionUi.currentItem}
      isComplete={sessionUi.isComplete}
      questionIndex={sessionUi.questionIndex}
      total={sessionUi.total}
      handleRestartClick={sessionUi.handleRestartClick}
      progressPercent={sessionUi.progressPercent}
      beginDrag={sessionUi.beginDrag}
      updateDrag={sessionUi.updateDrag}
      endDrag={sessionUi.endDrag}
      interactionLocked={sessionUi.interactionLocked}
      cardBorderClass={sessionUi.cardBorderClass}
      cardStyle={sessionUi.cardStyle}
      commitResponse={sessionUi.commitResponse}
      optionButtonClass={sessionUi.optionButtonClass}
      submitError={sessionUi.submitError}
      handleTryAgainClick={sessionUi.handleTryAgainClick}
      clusterScores={sessionUi.clusterScores}
      hasCompletedInterestTest={hasCompletedInterestTest}
      onShowResults={onShowResults}
      sidebarLayout={sidebarLayout}
      triGroup={{
        currentRound: sessionUi.currentRound,
        nextRound: sessionUi.nextRound,
        totalRounds: sessionUi.totalRounds,
        completedRounds: sessionUi.completedRounds,
        canContinueNextRound: sessionUi.canContinueNextRound,
        handleContinueNextRound: sessionUi.handleContinueNextRound,
        allRoundsComplete: sessionUi.allRoundsComplete,
        scoringCount: sessionUi.scoringCount
      }}
    />
  );
}

export default InterestTriGroupSwipeSession;
